import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import qDocPromise from 'config/qDoc';
import styles from './styles';

class Timeout extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  state = {
    timedout: false,
  }

  componentDidMount() {
    this.subscribeToTimeout();
  }

  subscribeToTimeout = async () => {
    const qDoc = await qDocPromise;
    qDoc.on('closed', () => { this.setState({ timedout: true }); });
  }

  handleRefresh = () => {
    // Refresh the page
    window.location.reload();
  }

  render() {
    const { classes } = this.props;
    const { timedout } = this.state;
    return (
      <div className={classes.root} style={{ display: timedout ? 'flex' : 'none' }}>
        <div className={classes.container}>
          <p>The session has timed out. Please refresh the page.</p>
          <button onClick={this.handleRefresh} className={classes.btnOutline}>Refresh</button>
        </div>
      </div>
    );
  }
}

export default injectSheet(styles)(Timeout);
